import ManagerRepository from 'brandClasses/ManagerRepository';
import Manager from 'coreClasses/Manager';
import {
	selectConfigurations
} from 'coreStore/data/configurations';
import _get from 'lodash/get';

/**
 * Represents ConfigurationsMgr
 */
class ConfigurationsMgr extends Manager {
	private cache: any;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 */
	constructor(managerRepository: ManagerRepository) {
		super(managerRepository);
		this.cache = {};
	}

	/**
	 * Returns configuration by path
	 * @param {String} configurationPath Path to object property of configuration object
	 * @returns {Object}
	 */
	get(configurationPath: string) {
		if (!(configurationPath in this.cache)) {
			const store = this.managerRepository.getStoreMgr().getStore();
			const configurations = selectConfigurations(store.getState());
			const value = _get(configurations, configurationPath);

			if (value !== undefined) {
				this.cache[configurationPath] = _get(configurations, configurationPath);
			}
		}

		return this.cache[configurationPath];
	}

	/**
	 * Removes configuration from cache
	 * @param {String} configurationPath Path to object property of configuration object
	 */
	invalidateCache(configurationPath: string) {
		delete this.cache[configurationPath];
	}

	/**
	 * Removes all configuration from cache
	 */
	invalidateAllCache() {
		this.cache = {};
	}
}

export default ConfigurationsMgr;
